module.exports = require("@mui/icons-material/CenterFocusStrong");